import React from 'react';
import { Building2 } from 'lucide-react';
import { clientLogos } from '../data/mock';

const Clients = () => {
  return (
    <section id="clients" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Trusted by <span className="text-blue-600">Industry Leaders</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We're proud to serve some of the most respected companies across various industries
          </p>
        </div>

        {/* Stats Banner */}
        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-2xl p-8 mb-12 text-center">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <div className="text-4xl font-bold text-white mb-2">500+</div>
              <div className="text-blue-100">Happy Clients</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-white mb-2">10,000+</div>
              <div className="text-blue-100">Workforce Deployed</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-white mb-2">6 States</div>
              <div className="text-blue-100">Pan-India Presence</div>
            </div>
          </div>
        </div>

        {/* Client Logos Grid */}
        <div className="max-w-6xl mx-auto mb-16">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {clientLogos.map((client, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300 h-24 flex items-center justify-center group border border-gray-100"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Additional Trust Indicators */}
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="bg-blue-50 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
              <Building2 className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Fortune 500</h3>
            <p className="text-sm text-gray-600">Serving multiple Fortune 500 companies</p>
          </div>
          <div className="text-center">
            <div className="bg-cyan-50 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
              <Building2 className="w-8 h-8 text-cyan-600" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Multi-Industry</h3>
            <p className="text-sm text-gray-600">Expertise across manufacturing, retail, hospitality & more</p>
          </div>
          <div className="text-center">
            <div className="bg-teal-50 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
              <Building2 className="w-8 h-8 text-teal-600" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Long-term Partnerships</h3>
            <p className="text-sm text-gray-600">Building lasting relationships with our clients</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;